// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=OkResponseWrappingIndustryList|schemaHash=c2a7425579edaa6e20a4713ba0382adf358e9131

import { setDefinedValue } from '@myre/common-primitives';

import { parseIndustryFromJSON, parseIndustryToJSON } from './Industry';
import { parseResponseMetaFromJSON, parseResponseMetaToJSON } from './ResponseMeta';

export function parseOkResponseWrappingIndustryListFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'meta',
    parseResponseMetaFromJSON(
      _data.meta
    ),
  );
  setDefinedValue(
    result,
    'content',
    Array.isArray(_data.content)
      ? _data.content.map(item =>
          parseIndustryFromJSON(item),
        )
      : _data.content,
  );
  setDefinedValue(result, 'status', _data.status);

  return result;
}

export function parseOkResponseWrappingIndustryListToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'meta',
    parseResponseMetaToJSON(
      _data.meta
    ),
  );
  setDefinedValue(
    result,
    'content',
    Array.isArray(_data.content)
      ? _data.content.map(item =>
          parseIndustryToJSON(item),
        )
      : _data.content,
  );
  setDefinedValue(result, 'status', _data.status);

  return result;
}
